<template>
    <div class="view-max-shell">
        <div class="w-view-shell">
            <div class="crumbs-shell">
                当前位置：
                <router-link to="/"> 首页</router-link>
                > 名师风采
            </div>
            <!-- 名师风采 -->
            <div class="teacher-list">
                <div class="teacher-box" v-for="(item,index) in teacher_list" :key="index"
                     @click="select_tec(item,index)">
                    <img :src="item.lector_img" alt="" class="teacher-img">
                    <div class="teacher-info">
                        <div class="teacher-name">
                            <div class="name">{{item.lector_name}}</div>
                            <div class="coures-num">课程: {{item.cnt_course}}</div>
                        </div>
                        <div class="teacher-desc">{{item.lector_desc.length>147?item.lector_desc.substring(0,147)+'...':item.lector_desc}}</div>
                    </div>
                </div>
                <!--                <div class="el-pagination">-->
                <!--                    <el-pagination-->
                <!--                            @current-change="handleCurrentChange"-->
                <!--                            :current-page="page"-->
                <!--                            :page-size="page_size"-->
                <!--                            background layout="prev, pager, next" :total="total"></el-pagination>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'teacher',
    data () {
      return {
        show: true,
        teacher_list: [],
        lector_id: 1,
        lector_info: {
          course_list: []
        },
        page: 1,
        total: 0,
        page_size: 100
      }
    },
    mounted () {
      window.scrollTo(0, 0)
      this.get_list()
    },
    methods: {
      select_tec (item, index) {
        this.lector_id = item.lector_id
        this.$router.push({
          path: '/teacher-detail',
          query: {
            lector_id: this.lector_id
          }
        })
      },
      get_list () {
        this.API.post('Home/lector_out-get_teacher_list', {
          page: this.page,
          page_size: this.page_size
        }).then((res) => {
          this.teacher_list = res.data.teacher_list
        })
      },
    }
  }
</script>

<style lang="less" scoped>
    .view-max-shell {
        background-color: #f4f4f4;
        min-height: 100vh;
    }

    .teacher-list {
        background-color: #fff;
        margin-bottom: 75px;

        .teacher-box {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #dcdcdc;
            padding: 50px 30px;
            overflow: hidden;
            cursor: pointer;

            .teacher-img {
                width: 150px;
                min-width: 150px;
                height: 150px;
                margin-right: 20px;
            }
            .teacher-info{
                width: 90%;
            }
            .teacher-name{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #000000;
                margin-bottom: 20px;
                .name{
                    width: 80%;
                }
            }
            .coures-num {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #2AA9B5;
                margin-top: -10px;
            }
            .teacher-desc{
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                line-height: 28px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                -o-text-overflow: ellipsis; /* for Opera */
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }

    .crumbs-shell {
        display: flex;
        align-items: center;
        height: 96px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }
</style>
